import { RouterOutlet } from '@angular/router';
import { Component } from '@angular/core';
import { JobWrapper } from '@shared/components/job-wrapper/job-wrapper';

@Component({
  selector: 'ta-ticket-wrapper',
  template: `
    <ta-job-wrapper [visible]="true">
      <router-outlet />
    </ta-job-wrapper>
  `,
  imports: [RouterOutlet, JobWrapper]
})
export class TicketWrapper {}
